import "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/core-js/modules/es.array.iterator.js";
import "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/core-js/modules/es.promise.js";
import "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/core-js/modules/es.object.assign.js";
import "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/core-js/modules/es.promise.finally.js";
import Vue from 'vue';
import envCheck from '@vip-activity/business/envCheck';
import { checkEndTime, getShareParams } from '@vip-activity/business/pageSetting';
import { setExtraStyle } from '@vip-activity/utils/style';
import MagicService from '@vip-activity/business/service/magic';
import CommonService from '@vip-activity/business/service/common';
import store from '@/store';
import App from '@/App.vue';
import '@/plugins';
import '@/mixin';
import { setShare, processShareLink, setTitle } from '@/util';
Vue.config.productionTip = false;
Vue.prototype.setting = window.setting;
Vue.prototype.magicService = new MagicService(window.setting.魔方.活动ID);
Vue.prototype.commonService = CommonService;
Vue.prototype.eventBus = new Vue();
envCheck(function () {
  var _window$setting, _window$setting$额外样式;

  new Vue({
    store: store,
    render: function render(h) {
      return h(App);
    }
  }).$mount('#app');
  processShareLink();
  checkEndTime();
  setTitle();
  setShare(getShareParams(window.pageSetting));
  setExtraStyle((_window$setting = window.setting) === null || _window$setting === void 0 ? void 0 : (_window$setting$额外样式 = _window$setting.额外样式) === null || _window$setting$额外样式 === void 0 ? void 0 : _window$setting$额外样式.css);
});